import { Component, Input, Output, EventEmitter} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Tool } from '@cyborg-monorepo/hunter/common'; // assuming correct import path
import { LogoComponent, getIconForProduct, IconComponent, TypographyComponent } from '@hyperkit'
import { QueryClickEvent } from '../../../hunt-package-details/hunt-package-details.component';

interface Endpoint {
  name: string;
  status: 'loading' | 'complete';
}
@Component({
  selector: 'hunt-query-card',
  imports: [CommonModule, LogoComponent, IconComponent, TypographyComponent],
  templateUrl: './hunt-query-card.component.html',
  styleUrl: './hunt-query-card.component.scss',
})
export class HuntQueryCardComponent {
  @Input() tool: Tool;
  @Input() selectedQueryId: string | null = null;

  @Input() isHuntComplete: boolean;
  @Output() queryClick = new EventEmitter<QueryClickEvent>();

  isOpen = true;

  toggle() {
    this.isOpen = !this.isOpen;
  }  

  // UNCOMMENT: Whenever we update the API for stutus on queries
  // get totalQueries(): number {
  //   return this.tool.fieldMappings.length;
  // }
// get completedQueries(): number {
  //   return this.tool.fieldMappings.filter(e => e.status === 'complete').length;
  // }
  

    // 👇 expose the function for template usage
    getIconForProduct = getIconForProduct;


}
